import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import ZoneService from '../../services/zone-service';

import Address from '../order/address';
import LineItem from '../order/line-item';

class ConfirmationDetail extends Component {
    constructor(props) {
        super(props);

        document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
    }

    _shipmentLineItemsMarkup() {
        return this.props.stores && this.props.stores
            .filter((store) => this.props.order.line_items.findIndex((item) => item.attributes.store_id === store.id) !== -1)
            .map((store, index) => (
                <div style={{ paddingBottom: 30 }} key={index}>
                    <h3>
                        { store.name }
                    </h3>
                    <div>
                        { this.props.order.line_items
                            .filter((item) => item.attributes.store_id === store.id)
                            .map((lineItem, idx) => (
                                <LineItem lineItem={lineItem} key={idx} />))}
                    </div>
                </div>
            ));
    }

    render() {
        return (
            <div className="confirmation-form__container" style={{ width: '100%' }}>
                <div className="row">
                    <div className="col-md-6">
                        <h4>
                            <FormattedMessage id="billingAddress" defaultMessage="Billing Address" />
                            :
                        </h4>
                        {this.props.order.bill_address && (
                            <Address address={this.props.order.bill_address} />
                        )}
                    </div>
                    {!ZoneService.isDonationZone() && (
                        <div className="col-md-6">
                            <h4>
                                <FormattedMessage id="shippingAddress" defaultMessage="Shipping Address" />
                                :
                            </h4>
                            {this.props.order.ship_address && (
                                <Address address={this.props.order.ship_address} />
                            )}
                        </div>
                    )}
                </div>
                <hr />
                <div className="form-group">
                    <div className="col-md-12">
                        <h4>
                            <FormattedMessage id="orderItems" defaultMessage="Order Items" />
                        </h4>
                        {this._shipmentLineItemsMarkup()}
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(ConfirmationDetail);



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/confirmation-detail.jsx
 **/